import { Controller } from '@hotwired/stimulus'
import * as barChart from '~/app/d3charts/bar_chart/bar_chart'

export default class extends Controller {
  static values = {
    dataSets: Array,
    containerSelector: String,
    title: String,
    xAxis: Array,
    yAxis: Array,
    yAxisUnit: String
  }

  dataSetsValueChanged() {
    barChart.build(this.dataSetsValue, this.containerSelectorValue, this.xAxisValue, this.yAxisValue)
  }
}
